import { Component, ChangeDetectionStrategy, inject} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { AuthService } from '@auth0/auth0-angular';

@Component({
    selector: 'gcp-workspace-login',
    imports: [MatButton],
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent {
  private readonly auth = inject(AuthService);

  
  handleLogin(): void {
    const redirectHost = window.location.origin
    const loginWithRedirectParams = {
      appState: {
        target: '/homepage'
      },
      authorizationParams: {
        redirect_uri: redirectHost + '/#/callback'
      }
    }
    this.auth.loginWithRedirect(loginWithRedirectParams);
  }
}
